import { IOrderTotalsModel } from "@app/checkout/checkout.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const cartAdapter: EntityAdapter<IOrderTotalsModel> = createEntityAdapter<IOrderTotalsModel>({
	selectId: cart => cart.orderId
});